// @ts-check

function toDate(value) {
  if (!value) return null;

  return new Date(Date.parse(value));
}

/**
 * @constructor
 * @param {typeof import('moment')} moment
 */
export function ProviderAccountViewModelService(moment, formatDate, formatDateAsRelative) {
  var self = this;

  /**
   * @param {import('core-services/provider-accounts.service').ArchivedProviderAccount[]} providerAccounts
   * @return {import('types/index').ProviderAccountWithArchivesVM[]}
   */
  this.buildModelsWithArchives = function(providerAccounts) {
    if (!providerAccounts) return [];

    return providerAccounts.map(_ => ({
      id: _.id,
      institutionName: _.institution.name,
      availableSources: _.availableSources || [],
      accounts: (_.accounts || [])
        .map(account => this.buildAccountModel(account)),
      '@presenting': _,
    }));

  };

  this.buildModels = function(providerAccounts) {
    if (!providerAccounts)
      return [];

    return providerAccounts
      .map(function(providerAccount) { return self.buildModel(providerAccount); });
  };

  /**
   * @param {import("types/api").AccountFromAPI} account
   * @return {import("types/index").ProviderAccountViewModel.AccountViewModel}
   */
  this.buildAccountModel = function(account) {
    return {
      id: account.id,
      institutionName: account.institution.name,
      accountName: account.name,
      accountNumber: account.number,
      "@presenting": account,
    };
  }


  /**
   * @param {import('types/api').ProviderAccountFromAPI} providerAccount
   * @return {import('types/index').ProviderAccountViewModel}
   */
  this.buildModel = function(providerAccount) {
    const refresh =
      angular.merge(
        {},
        providerAccount.refreshInfo || {},
        providerAccount.refreshScheduler || {},
        providerAccount.refreshEligibility || {},
      );

    return {
      id: providerAccount.id,
      institutionName: providerAccount.institution.name,
      eligibleForRefresh: providerAccount.refreshEligibility.status == "ALLOWED",
      recentlyRefreshed: providerAccount.refreshEligibility.reasonCode == "RECENT_REFRESH",
      isRefreshStale: refresh.lastRefreshedAt
        ? moment(refresh.lastRefreshedAt).isBefore( moment().subtract(36, 'hours') )
        : false,
      lastRefreshedAt: formatDate(refresh.lastRefreshedAt),
      lastRefreshedAtAsRelative: formatDateAsRelative(refresh.lastRefreshedAt),
      lastAttemptedAt: formatDate(refresh.lastAttemptedAt),
      nextRefreshScheduledAt: formatDate(refresh.nextRefreshScheduledAt),
      backgroundRefreshStatus: refresh.status,
      actionPending: false,
      links: {
        refreshAccountWithMfaHref: "/fastlink/refreshAccount/" + encodeURIComponent(providerAccount.id),
        editAccountHref: "/fastlink/editAccount/" + encodeURIComponent(providerAccount.id),
      },
      refreshInfo: {
        lastRefreshedAt: toDate(providerAccount.refreshInfo && providerAccount.refreshInfo.lastRefreshedAt),
        lastRefreshedTimeAt: toDate(providerAccount.refreshInfo && providerAccount.refreshInfo.lastRefreshedAt),
        lastAttemptedAt: toDate(providerAccount.refreshInfo && providerAccount.refreshInfo.lastAttemptedAt),
      },
      refreshScheduler: {
        status: providerAccount.refreshScheduler.status,
        nextScheduledAt: toDate(providerAccount.refreshScheduler.nextScheduledAt),
      },
      refreshEligibility: {
        status: providerAccount.refreshEligibility.status,
        reasonCode: providerAccount.refreshEligibility.reasonCode,
      },
      statusIndicator: statusIndicatorFor(providerAccount),
      accounts: (providerAccount.accounts || [])
        .map(account => this.buildAccountModel(account)),
      '@presenting': providerAccount,
    };
  };

  /**
   * Returns a status indicator for a given provider account.
   *
   * @param {import('types/api').ProviderAccountFromAPI} providerAccount
   * @return {import('types/index').ProviderAccountViewModel['statusIndicator']}
   */
  function statusIndicatorFor( providerAccount ) {
    /** @type {import('types/index').ProviderAccountViewModel['statusIndicator']['code']} */
    var code = 'GREEN';

    if (providerAccount.refreshInfo) {
      if (providerAccount.refreshInfo.status == 'IN_PROGRESS') {
        code = 'SPINNER';
      } else if (providerAccount.refreshInfo.status == 'FAILURE') {
        code = 'RED';
      }
    }

    var iconSrc = null;

    switch ( code ) {
      case "RED":
        iconSrc = "images/flat-round-red-alert.png";
        break;
      case "GREEN":
        iconSrc = "images/flat-round-green-dot.png";
        break;
    }
    return {
      code,
      iconSrc,
    };
  }
};

export default ProviderAccountViewModelService;

// import { ProviderAccountFromAPI } from 'types/api';
// import { ProviderAccountWithArchivesVM, ProviderAccountViewModel } from 'types';
// import { ArchivedProviderAccount } from '../provider-accounts.service';
// import { AccountFromAPI } from 'types/api';
// import { AccountViewModel } from 'javascripts/sheet.controller';

// export interface ProviderAccountViewModelService {
//   (this: ProviderAccountViewModelService): void;

//   buildModelsWithArchives(providerAccounts: ArchivedProviderAccount[]): ProviderAccountWithArchivesVM[];
//   buildModels(providerAccounts: ProviderAccountFromAPI[]): ProviderAccountViewModel[];
//   buildModel(providerAccount: ProviderAccountFromAPI): ProviderAccountViewModel;
//   buildAccountModel(account: AccountFromAPI): AccountViewModel;
// }

// export default ProviderAccountViewModelService;

